export const boolDialogCtrl = function($scope, $modalInstance, $timeout, message) {
  $scope.message = message;
  $scope.close = function() {
    $modalInstance.close(false);
  };
  $scope.ok = function() {
    $modalInstance.close(true);
  };
};

/* ---------------------------------------------- */
/* helloDialogCtrl */

export const helloDialogCtrl = function($scope, $modalInstance, $cookies) {
  $scope.close = function() {
    $cookies.put('notShowHello', $scope.notShowHello);
    $modalInstance.close();
  };
  $scope.change = function() {
    $scope.notShowHello = !$scope.notShowHello;
  };
};

export const configureAccountCtrl = function(
  $http,
  $scope,
  $modalInstance,
  accountCell,
  accountData,
) {

  $scope.accountCell = accountCell;
  $scope.accountData = accountData['data'];
  $scope.formErrors = accountData['errors'];

  $scope.ok = function() {
    if ($scope.accountData.email == '') {
      $scope.formErrors['email'] = [gettext('Введите емэйл!')];
      return;
    }

    $http.post(
        '/accounts/configacc/' + $scope.accountCell['agent_account.id'],
        $scope.accountData,
      )
      .then(function({
        data
      }) {
        console.log('Saved profile: ' + data);
        if (!data['errors'] || data['errors'].length == 0) {
          $modalInstance.close(gettext('Пароль для ') + $scope.accountData['email'] + gettext(
            ' отправлен.'));
        }
        $scope.formErrors = data['errors'];
      })
      .catch(function({
        data,
        status,
        headers,
        config
      }) {
        console.log(status, data);
      });

    //     $modalInstance.close($scope.accountData);
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };

};

/* ---------------------------------------------- */
/* showImageDialogCtrl */

export const updatesCtrl = function($scope, $modalInstance, $http, PermissionService) {
  $scope.close = function() {
    $modalInstance.close();
  };
  $scope.ok = function(action) {
    $modalInstance.close(action);
  };
  $scope.fromData = function(data) {
    if (PermissionService.selectedLang === 'ru') {
      $scope.changeListUrl = 'https://docs.staffcop.ru/update/changelog.html';
    } else {
      $scope.changeListUrl = 'https://docs.staffcop.com/update/changelog_en.html';
    }
    $scope.settings_server_version = data['settings_server_version'];
    $scope.settings_agent_version = data['settings_agent_version'];
    $scope.settings_linux_agent_version = data['settings_linux_agent_version'];
    $scope.settings_macos_agent_version = data['settings_macos_agent_version'];
    $scope.agent_update_required = data['agent_update_required'];
    $scope.clickhouse_available = data['clickhouse_available'];
    $scope.message = data['message'];
  };
  $scope.init = function() {
    $scope.fromData({});
    $http.get('/analytics/update_agent/')
      .then(function({
        data
      }) {
        $scope.fromData(data);
      })
      .catch(function({
        data,
        status,
        headers,
        config
      }) {
        console.log(status, data);
      });
  };
  $scope.update_agent = function() {
    $http.post('/analytics/update_agent/')
      .then(function({
        data
      }) {
        $scope.fromData(data);
      })
      .catch(function({
        data,
        status,
        headers,
        config
      }) {
        console.log(status, data);
      });
  };
  $scope.init();
};



// WEBPACK FOOTER //
// ./src/admin/modals.js